<script src="https://cdn.jsdelivr.net/vue/latest/vue.js"></script>
<template>
  <div>
    <h5 class="display-5">Subject Preferences</h5>
    <h6 class="display-6">
      The followings are the subject you are currently learning.
    </h6>
    <br /><br />
    <CCard class="h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12">
              <CRow>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-4"
                >
                  <div class="custom-width-lg">
                    <CRow class="justify-content-center">
                      <CCol sm="12" lg="12">
                        <CCardBody>
                          <div id="myapp">
                            <h4 align="left">Academic</h4>
                            <template>
                              <div form class="checkbox-form">
                                <div class="answers">
                                  <label
                                    v-for="item in Academics"
                                    v-bind:key="item.Id"
                                    class="item"
                                  >
                                    <input
                                      type="checkbox"
                                      v-model="item.isAccepted"
                                    />
                                    <span class="text-dark">{{
                                      item.SubjectName
                                    }}</span>
                                    <span class="checkmark" />
                                  </label>
                                </div>
                              </div>
                            </template>
                            <br />
                            <!-- Checkboxes list Competition-->
                            <h4 align="left">Competition</h4>
                            <template>
                              <div form class="checkbox-form">
                                <div class="answers">
                                  <label
                                    v-for="item in Competitions"
                                    v-bind:key="item.Id"
                                    class="item"
                                  >
                                    <input
                                      type="checkbox"
                                      v-model="item.isAccepted"
                                    />
                                    <span class="text-dark">{{
                                      item.Name
                                    }}</span>
                                    <span class="checkmark" />
                                  </label>
                                </div>
                              </div>
                            </template>
                            <br />

                            <!-- Check All -->
                            <template>
                              <div form class="checkbox-form">
                                <div class="answers">
                                  <label class="item">
                                    <input
                                      type="checkbox"
                                      @click="checkAll()"
                                      v-model="isCheckAll"
                                    />
                                    Select All Subject
                                    <span class="checkmark" />
                                  </label>
                                </div>
                              </div>
                            </template>
                          </div>
                        </CCardBody>

                        <CCardFooter>
                          <CButton
                            color="success"
                            class="custom-btn mt-2"
                            size="lg"
                            block
                            @click="UpdateStudentStatus"
                            >Update</CButton
                          >
                        </CCardFooter>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundBanner from "../assets/img/bgApps.jpg";
export default {
  name: "Login",
  el: "#myapp",
  data() {
    return {
      backgroundBanner,
      isCheckAll: false,
      Academics: [],
      Competitions: [],
      subject: [],
      selectedlang: "",
    };
  },
  async mounted() {
    this.GetSubject();
  },
  methods: {
    async GetSubject() {
      this.Academics = [];
      this.$API
        .get(this.$QuizSubjectList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Academics = response.data;
          }
        });
    },
    UpdateStudentStatus() {
      const formData = new FormData();

      var combinedSubject = [];
      for (let i in this.Academics) {
        let item = this.Academics[i];
        if (item.isAccepted === true) {
          combinedSubject.push({
            subjectId: item.Id,
            subjectName: item.SubjectName,
            IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
          });
        }
      }

      let subjectData = JSON.stringify(combinedSubject);
      console.log(subjectData);
      formData.append("subjectJson", subjectData);
      formData.append("studentId", this.$route.query.studentId);
      formData.append("gradeId", this.$route.query.gradeId);

      return this.$API
        .post(this.$StudentUpdateStatus, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //  this.successModal = true;
            // this.GoToPageStatus(response.data);
            this.Academics = [];
            this.GoToDashBoard();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },
    checkAll() {
      this.isCheckAll = !this.isCheckAll;
      this.subject = [];
      if (this.isCheckAll) {
        // Check all
        for (let i in this.Academics) {
          let acad = this.Academics[i];
          if (acad.isAccepted == undefined) {
            acad.isAccepted = true;
          } else if (acad.isAccepted == false) {
            acad.isAccepted = true;
          }
        }

        for (let i in this.Competitions) {
          let comp = this.Competitions[i];
          if (comp.isAccepted == undefined) {
            comp.isAccepted = true;
          } else if (comp.isAccepted == false) {
            comp.isAccepted = true;
          }
        }
      } else {
        for (let i in this.Academics) {
          let acad = this.Academics[i];
          if (acad.isAccepted == true) {
            acad.isAccepted = false;
          }
        }

        for (let i in this.Competitions) {
          let comp = this.Competitions[i];
          if (comp.isAccepted == true) {
            comp.isAccepted = false;
          }
        }
      }
    },
    updateCheckall() {
      if (this.subject.length == this.options.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
  },
};
</script>

<style>
.checkbox-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
}

.checkbox-form .answers {
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 100%;
}

.checkbox-form label {
  margin-left: 1em;
}

.checkbox-form .item {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 10px;
  cursor: pointer;
  font-size: 1em;
  height: 28px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
}

.checkbox-form .item input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkbox-form .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #c2c2c2;
  border-radius: 50px;
}

.checkbox-form .item:hover input ~ .checkmark {
  background-color: #d0d0e6;
}

.checkbox-form .item input:checked ~ .checkmark {
  background-color: #7716d1;
}

.checkbox-form .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-form .item input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-form .item .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>